<!-- Start Breadcrumb
============================================= -->
<div class="breadcrumb-area bg-cover shadow theme-hard text-center text-light" style="background-image: url(assets/img/banner/8.jpg);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1>Featured Projects</h1>
        <ul class="breadcrumb">
          <li><a routerLink="/"><i class="fas fa-home"></i> Home</a></li>
          <li>Portfolio</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- End Breadcrumb -->
<!-- Start Project Details Area
============================================= -->
<div class="project-details-area default-padding">
  <div class="container">
    @for (project of projects; track project.title; let first = $first; let odd = $odd) {
      <div class="project-details-items default-padding" [class.bg-gray]="odd" [class.mt-100]="!first" [class.mt-xs-40]="!first">
        <div class="top-info">
          <div class="row">
            <div class="col-xl-4 col-lg-5 order-lg-last right-info">
              <div class="project-info">
                <h4 class="title">Project Info</h4>
                <ul>
                  <li>
                    Category <span>{{ project.category }}</span>
                  </li>
                  @if (project.client) {
                    <li>
                      Client <span>{{ project.client }}</span>
                    </li>
                  }
                  @if (project.franchaise) {
                    <li>
                      Franchise <span>{{ project.franchaise }}</span>
                    </li>
                  }
                  @if (project.product) {
                    <li>
                      Product <span>{{ project.product }}</span>
                    </li>
                  }
                  @if (project.modules) {
                    <li>
                      Modules <span>{{ project.modules }}</span>
                    </li>
                  }
                  <li>
                    Delivery <span>Enterprise-grade digital solution</span>
                  </li>
                </ul>
                @if (project.url) {
                  <a [href]="project.url" target="_blank">Explore Product <i class="fas fa-external-link-alt"></i></a>
                } @else {
                  <a routerLink="/contact">Inquire Details <i class="fas fa-angle-double-right"></i></a>
                }
              </div>
            </div>

            <div class="col-xl-8 col-lg-7 pr-35 pr-md-15 pr-xs-15 left-info mt-md-10">
              <h2 class="title">{{ project.title }}</h2>
              <p>
                {{ project.summary }}
              </p>
            </div>
          </div>
        </div>
        <div class="item-grid-container">
          <div class="single-grid">
            <div class="item-grid-colum">
              <div class="left-info">
                <h2>Key Highlights</h2>
              </div>
              <div class="right-info">
                <ul class="list-style-two">
                  @for (highlight of project.highlights; track highlight) {
                    <li>{{ highlight }}</li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
<!-- End Project Details Area -->
